var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toggle_off_FILL0_wght400_GRAD0_opsz48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.28906 18.75C5.55295 18.75 4.07726 18.1424 2.86198 16.9271C1.6467 15.7118 1.03906 14.2361 1.03906 12.5C1.03906 10.7639 1.6467 9.28819 2.86198 8.07292C4.07726 6.85764 5.55295 6.25 7.28906 6.25H17.7057C19.4418 6.25 20.9175 6.85764 22.1328 8.07292C23.3481 9.28819 23.9557 10.7639 23.9557 12.5C23.9557 14.2361 23.3481 15.7118 22.1328 16.9271C20.9175 18.1424 19.4418 18.75 17.7057 18.75H7.28906ZM7.28906 17.1875H17.7057C19.0078 17.1875 20.1146 16.7318 21.026 15.8203C21.9375 14.9089 22.3932 13.8021 22.3932 12.5C22.3932 11.1979 21.9375 10.0911 21.026 9.17969C20.1146 8.26823 19.0078 7.8125 17.7057 7.8125H7.28906C5.98698 7.8125 4.88021 8.26823 3.96875 9.17969C3.05729 10.0911 2.60156 11.1979 2.60156 12.5C2.60156 13.8021 3.05729 14.9089 3.96875 15.8203C4.88021 16.7318 5.98698 17.1875 7.28906 17.1875ZM7.26148 15.1302C7.99168 15.1302 8.61285 14.8746 9.125 14.3635C9.63715 13.8524 9.89323 13.2317 9.89323 12.5015C9.89323 11.7713 9.63766 11.1502 9.12654 10.638C8.61541 10.1259 7.99475 9.86979 7.26456 9.86979C6.53437 9.86979 5.91319 10.1254 5.40104 10.6365C4.88889 11.1476 4.63281 11.7683 4.63281 12.4985C4.63281 13.2287 4.88838 13.8498 5.39951 14.362C5.91063 14.8741 6.53129 15.1302 7.26148 15.1302Z",
    fill: "#2FF77A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.c9b1d876c8ec079419d8565a57c7e944.svg";
export { ForwardRef as ReactComponent };